import React, { useEffect, useState } from 'react';
import { Container } from '../components/common/Container';
import { Button } from '../components/common/Button';
import { Eyebrow, Badge } from '../components/common/Badge';
import { Icon } from '../lib/icons';
import { dataService } from '../services/dataService';
import { PartnerLandingSection } from './PartnerLandingSection';
import { HostPlansSection } from './HostPlansSection';

function PlatformPreview({ preview }) {
  const tiles = [
    { icon: 'calendar', label: 'Eventi' },
    { icon: 'mapPin', label: 'Vicino a te' },
    { icon: 'landmark', label: 'Arte Musei' },
    { icon: 'concierge', label: 'Servizi' }
  ];
  return (
    <div className="relative rounded-card border border-paelbi-line bg-white p-3 shadow-lift">
      <div className="relative overflow-hidden rounded-[12px]">
        <img
          src={preview.image}
          alt="Anteprima della piattaforma PAELBI"
          loading="lazy"
          className="h-56 w-full object-cover md:h-64"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/10 text-center text-white">
          <span className="font-display text-xl tracking-[0.25em]">PAELBI</span>
          <span className="mt-1 text-[9px] uppercase tracking-[0.3em]">Il tuo B&amp;B</span>
          <p className="mt-3 max-w-[220px] text-xs text-white/90">
            Scopri il meglio del territorio e rendi speciale il tuo soggiorno.
          </p>
        </div>
      </div>

      {/* mini event card */}
      <div className="mt-3 flex items-center gap-3 rounded-[12px] border border-paelbi-line bg-paelbi-bg p-3">
        <div className="flex-1">
          <Badge>Eventi</Badge>
          <h4 className="mt-1 font-display text-base text-paelbi-ink">{preview.cardTitle}</h4>
          <p className="text-xs text-paelbi-ink/70">{preview.cardText}</p>
        </div>
      </div>

      {/* tiles */}
      <div className="mt-3 grid grid-cols-4 gap-2">
        {tiles.map((t) => (
          <div key={t.label} className="flex flex-col items-center gap-1 rounded-[12px] border border-paelbi-line bg-white py-3">
            <Icon name={t.icon} size={20} className="text-paelbi-brown" />
            <span className="text-[10px] text-paelbi-ink/70">{t.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function DomiraLanding() {
  const [data, setData] = useState(null);
  useEffect(() => { dataService.getDomiraHome().then(setData); }, []);
  if (!data) return null;

  return (
    <div>
      {/* HERO */}
      <section className="py-14 md:py-20">
        <Container>
          <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
            <div className="animate-fade-up">
              <Eyebrow>{data.hero.eyebrow}</Eyebrow>
              <h1 className="mt-4 font-display text-[42px] leading-[1.08] text-paelbi-ink md:text-[58px]">
                {data.hero.title.map((line, i) => (
                  <span key={`h-${i}`} className="block">{line}</span>
                ))}
              </h1>
              <p className="mt-6 max-w-md font-sans text-lg leading-relaxed text-paelbi-ink/70">
                {data.hero.description}
              </p>
              <div className="mt-8 flex flex-wrap items-center gap-5">
                <Button to="/onboarding" variant="primary">{data.hero.primaryCta}</Button>
                <Button href="#funzionalita" variant="text" icon="arrowRight">{data.hero.secondaryCta}</Button>
              </div>
            </div>
            <div className="animate-fade-up">
              <PlatformPreview preview={data.preview} />
            </div>
          </div>
        </Container>
      </section>

      {/* INTRO / FEATURES */}
      <section id="funzionalita" className="py-14 md:py-20">
        <Container>
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="font-display text-3xl text-paelbi-ink md:text-[32px]">{data.intro.title}</h2>
            <p className="mt-4 font-sans text-base leading-relaxed text-paelbi-ink/70">{data.intro.description}</p>
          </div>
          <div className="mt-14 grid grid-cols-1 gap-10 md:grid-cols-3">
            {data.features.map((f) => (
              <div key={f.title} className="flex flex-col items-center text-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-paelbi-bg2">
                  <Icon name={f.icon} size={26} className="text-paelbi-brown" />
                </span>
                <h3 className="mt-5 font-display text-xl text-paelbi-ink">{f.title}</h3>
                <p className="mt-3 max-w-xs font-sans text-sm leading-relaxed text-paelbi-ink/70">{f.text}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* PRICING — Host plans carousel */}
      <HostPlansSection />

      {/* CTA BANNER */}
      <section id="perche" className="pb-16 md:pb-24">
        <Container>
          <div className="flex flex-col items-start gap-6 rounded-card bg-paelbi-bg2 p-8 md:flex-row md:items-center md:justify-between md:p-10">
            <div className="flex items-start gap-4">
              <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white sm:flex">
                <Icon name="leaf" size={22} className="text-paelbi-brown" />
              </span>
              <div>
                <h3 className="font-display text-2xl text-paelbi-ink">{data.ctaBanner.title}</h3>
                <p className="mt-2 font-sans text-base text-paelbi-ink/70">{data.ctaBanner.text}</p>
              </div>
            </div>
            <Button to="/paelbi" variant="primary" className="shrink-0" data-testid="cta-prova-domira">{data.ctaBanner.cta}</Button>
          </div>
        </Container>
      </section>

      {/* PARTNER SECTION */}
      <PartnerLandingSection />
    </div>
  );
}

export default DomiraLanding;
